import React, { useState, useEffect } from 'react';
import { FaPrint, FaBarcode, FaNetworkWired, FaMapMarkerAlt, FaExclamationTriangle } from 'react-icons/fa';
import axiosInstance from '../utils/axiosConfig';
import { Modal } from './common';
import './FormModal.css';

const MARCAS_IMPRESORAS = ['HP', 'Canon', 'Kyocera'];
const PROVEEDORES = ['DELCOP', 'SYSCOPY', 'CORP RZ'];

function AddPrinterModal({ isOpen, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    nombre: '',
    marca: '',
    modelo: '',
    serial: '',
    ip: '',
    url: '',
    proveedor: '',
    sede_id: ''
  });
  const [sedes, setSedes] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      axiosInstance.get('/api/sedes').then(res => setSedes(res.data)).catch(() => {});
      setFormData({ nombre: '', marca: '', modelo: '', serial: '', ip: '', url: '', proveedor: '', sede_id: '' });
      setError(null);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const payload = { ...formData };
      if (payload.sede_id) payload.sede_id = parseInt(payload.sede_id, 10);
      else delete payload.sede_id;

      const response = await axiosInstance.post('/api/impresoras', payload);
      onAdd(response.data.impresora);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <Modal.Header onClose={onClose}>Agregar Nueva Impresora</Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="add-printer-form">
          <div className="form-modal-section">
            <h3><FaPrint /> Información de la Impresora</h3>
            <div className="form-modal-grid">
              <div className="form-modal-group">
                <label htmlFor="nombre">
                  <FaPrint className="input-icon" /> Nombre
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Compras, Facturación"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="marca">
                  <FaPrint className="input-icon" /> Marca
                </label>
                <select id="marca" name="marca" value={formData.marca} onChange={handleChange} required>
                  <option value="">Seleccione una marca</option>
                  {MARCAS_IMPRESORAS.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>

              <div className="form-modal-group">
                <label htmlFor="modelo">
                  <FaPrint className="input-icon" /> Modelo
                </label>
                <input
                  type="text"
                  id="modelo"
                  name="modelo"
                  value={formData.modelo}
                  onChange={handleChange}
                  required
                  placeholder="Ej: MF1643, IR 525"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="serial">
                  <FaBarcode className="input-icon" /> Serial
                </label>
                <input
                  type="text"
                  id="serial"
                  name="serial"
                  value={formData.serial}
                  onChange={handleChange}
                  placeholder="Ej: 2TP17505"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="ip">
                  <FaNetworkWired className="input-icon" /> IP
                </label>
                <input
                  type="text"
                  id="ip"
                  name="ip"
                  value={formData.ip}
                  onChange={handleChange}
                  placeholder="Ej: 192.168.1.100"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="url">
                  <FaNetworkWired className="input-icon" /> URL
                </label>
                <input
                  type="text"
                  id="url"
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  placeholder="Ej: http://192.168.1.100"
                />
              </div>

              <div className="form-modal-group">
                <label htmlFor="proveedor">
                  <FaPrint className="input-icon" /> Proveedor
                </label>
                <select id="proveedor" name="proveedor" value={formData.proveedor} onChange={handleChange}>
                  <option value="">Seleccione un proveedor</option>
                  {PROVEEDORES.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>

              <div className="form-modal-group">
                <label htmlFor="sede_id">
                  <FaMapMarkerAlt className="input-icon" /> Sede
                </label>
                <select id="sede_id" name="sede_id" value={formData.sede_id} onChange={handleChange}>
                  <option value="">Seleccione una sede</option>
                  {sedes.map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
                </select>
              </div>
            </div>
          </div>

          {error && (
            <div className="form-modal-error">
              <FaExclamationTriangle />
              {error}
            </div>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onClose} className="btn btn-secondary">
          Cancelar
        </button>
        <button type="submit" form="add-printer-form" className="btn btn-primary" disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddPrinterModal;
